import PropTypes from "prop-types";
import { useFeatureFlag } from "./use-feature-flag";

const IsFlagged = ({ feature, children, inverse, render }) => {
  const { flagEnabled } = useFeatureFlag(feature);

  const show = inverse ? !flagEnabled : flagEnabled;

  const obj = { show };

  if (render) return render(obj);
  if (typeof children === "function") return children(obj);

  return show ? children : null;
};

IsFlagged.propTypes = {
  feature: PropTypes.string.isRequired,
  inverse: PropTypes.bool,
  children: PropTypes.any,
  render: PropTypes.func,
};

IsFlagged.defaultProps = {
  inverse: false,
  render: undefined,
  children: null,
};

export default IsFlagged;
